/**
 * Tailwind-native tone tokens — `bg-ok` / `text-warn` / etc. exist because
 * `--color-ok` etc. are declared in src/styles/tailwind.css's `@theme` block.
 * Same role as FishOil's statusStyles.ts, keyed by semantic tone.
 */
export type Tone = 'ok' | 'warn' | 'bad' | 'info' | 'primary' | 'critical' | 'off';

export const TONE_DOT_CLASS: Record<Tone, string> = {
  ok: 'bg-ok',
  warn: 'bg-warn',
  bad: 'bg-bad',
  info: 'bg-info',
  primary: 'bg-primary',
  critical: 'bg-critical',
  off: 'bg-neutral',
};

export const TONE_TEXT_CLASS: Record<Tone, string> = {
  ok: 'text-ok',
  warn: 'text-warn',
  bad: 'text-bad',
  info: 'text-info',
  primary: 'text-primary',
  critical: 'text-critical',
  off: 'text-neutral',
};

export const TONE_SOFT_BG_CLASS: Record<Tone, string> = {
  ok: 'bg-ok-light',
  warn: 'bg-warn-light',
  bad: 'bg-bad-light',
  info: 'bg-info-light',
  primary: 'bg-primary-light',
  critical: 'bg-critical-light',
  off: 'bg-neutral-light',
};

/** ~13% opacity halo ring behind a status dot. */
export const TONE_HALO_CLASS: Record<Tone, string> = {
  ok: 'shadow-[0_0_0_3px_rgba(31,138,95,0.13)]',
  warn: 'shadow-[0_0_0_3px_rgba(185,119,14,0.13)]',
  bad: 'shadow-[0_0_0_3px_rgba(192,57,43,0.13)]',
  info: 'shadow-[0_0_0_3px_rgba(59,111,182,0.13)]',
  primary: 'shadow-[0_0_0_3px_rgba(29,90,166,0.13)]',
  critical: 'shadow-[0_0_0_3px_rgba(207,74,12,0.13)]',
  off: 'shadow-[0_0_0_3px_rgba(93,107,124,0.13)]',
};

/** Raw CSS color per tone, for SVG fills/strokes. */
export const TONE_VAR: Record<Tone, string> = {
  ok: 'var(--color-ok)',
  warn: 'var(--color-warn)',
  bad: 'var(--color-bad)',
  info: 'var(--color-info)',
  primary: 'var(--color-primary)',
  critical: 'var(--color-critical)',
  off: 'var(--color-neutral)',
};
